import React from 'react';
import { ShoppingCart, Eye, MoreVertical, CheckCircle, PackageCheck } from 'lucide-react';
import style from 'react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark';

const InventoryCard = ({ item, selected, onSelect, onBarcode }) => {
  const {
    id,
    productImage,
    productName,
    category,
    subCategory,
    weight,
    price,
    discount
  } = item;

  return (
    <div className={`gi-card ${selected ? 'gi-selected' : ''}`} onClick={() => onSelect(id)}>
      {selected && (
        <div className="gi-selected-badge">
          <CheckCircle size={18} color="#28a745" />
        </div>
      )}
      <img src={productImage} alt={productName} className="gi-image" />

      <div className="gi-content">
        <h4 className="gi-title">{productName}</h4>
        <p className="gi-tags">
          <span>{category}</span> | <span>{subCategory}</span>
        </p>
        <p className="gi-weight">{weight}</p>
        <p className="gi-price">
          ₹{price}
          {discount !== "0.00" && <span className="gi-discount"> ₹{discount}</span>}
        </p>
      </div>

      <div className="gi-footer">
        <button className="gi-stock-button">+ Inventory</button>
        <div className="gi-footer-icons">
          <Eye size={18} className="gi-icon" />
          <ShoppingCart size={18} className="gi-icon" />

          <PackageCheck className='gi-icon' size={18} onClick={(e) => {
            e.stopPropagation(); 
            onBarcode(item);

          }} />

        </div>
      </div>
    </div>
  );
};

export default InventoryCard;
